<template>
  <div>

    <div class="top">
      <img src="../../assets/解决方案2@2x.png"
           alt="">
    </div>
    <div class="tab-bar">
      <div class="tab-box">
        <div :class="programme">
          <div class="test"
               @click="tab(2)">解决方案展示</div>
        </div>
        <div :class="product">
          <div class="test"
               @click="tab(1)">产品展示</div>
        </div>
      </div>
      <div class="p"></div>
    </div>
    <transition name="fade">
      <div v-if="switchtab==false"
           class="tab-one">
        <div class="lims">

          <img src="../../assets/bg3.png"
               alt="">
          <img class="web"
               src="../../assets/组 35@2x.png"
               alt="">
          <div class="bg">
            <div class="bg-title">瑞检医学实验室管理系统</div>
            <div class="bg-box">
              <div>
                瑞检IIMS是专门为国内第三方医学实验室研发的全新的信息管理系统，本系统参考国外先进管理经验，结合我国行业实际需求，完全符合IS015189及CAP质量认证要求。本系统覆盖所有医学检验类型，同时提供物流、实验室、销售、财务、客户等全方位整体化解决方案。瑞检LIMS不仅具有完备的常规医学检验所需的系统功能，同时它还满足各类精准医学检验对信息系统的个性化需求。瑞检LIMS不仅是一个信息系统，更是一个设计平台,根据不同的检验业务，支持自定义检验流程、 自定义录入窗体、自定义检验报告：根据不同的需求，对报告进行组合及拆分，适用于独立医学实验室、 区域检验中心等医疗机构。
              </div>
            </div>

          </div>
        </div>
        <div class="centerBox">
          <div class="shiyong">
            适用场景
            <div class="bg"></div>
          </div>
          <div class="border">

            <div class="me-box">
              <div class="me-box-test">
                <div class="me-box-test1">全流程业务管理，助力 第三方独立医学实验室 提质增效</div>
                <div class="me-box-test2">遵循ISO15189/CAP体系管理要求，基于人、机、料、法、环多个模块，帮助检测机构打造智慧型实验室</div>
              </div>
              <!-- <div class="me-box-test1">全流程业务管理，助力 第三方独立医学实验室 提质增效</div>
              <div class="me-box-test2">遵循ISO15189/CAP体系管理要求，基于人、机、料、法、环多个模块，帮助检测机构打造智慧型实验室</div> -->
              <div class="me-box-border">
                <div class="border-box">
                  <img class="border-box-img"
                       src="../../assets/集团型实验室.png"
                       alt="">
                  <div class="border-box-kuang">
                    <div class="box-kuang1">集团型实验室</div>
                    <div class="box-kuang2">医学实验室由原先区域化运营逐步形成全国布局模式，集团化运营需求持续增长</div>
                  </div>
                </div>
                <div class="border-box">
                  <img class="border-box-img"
                       src="../../assets/个性化实验室.png"
                       alt="">
                  <div class="border-box-kuang">
                    <div class="box-kuang1">个性化实验室</div>
                    <div class="box-kuang2">分子诊断技术、基因分析技术的提高，孕育着个性化实验室的数量将快速增长</div>
                  </div>
                </div>
                <div class="border-box">
                  <img class="border-box-img"
                       src="../../assets/临床研究实验室.png"
                       alt="">
                  <div class="border-box-kuang">
                    <div class="box-kuang1">临床研究实验室</div>
                    <div class="box-kuang2">智慧型系统，为临床研究、药物研究实验室提供全流程解决方案</div>
                  </div>
                </div>
              </div>
              <!-- <div class="top">
            <div class="test">适用场景</div>
          </div> -->
              <!-- <div class="box-model">
            <div class="model-border" v-for="(item,index) in tableData"
                 :key="index">
              <div class="model-top">
                <div>{{ item.title }}</div>
                <img :src="item.fileLocal+item.iconUrl"
                     alt="">
              </div>
              <div class="model-test">{{ item.describe }}</div>
            </div>
            
            <div class="model-border">
              <div class="model-border-image">更多功能<img style="width: 25px;height: 19px;margin-left: 10px;"
                     src="../../assets/更多-箭头.png"
                     alt=""></div>
            </div>
          </div> -->
            </div>

          </div>
        </div>
        <div class="product">
          <div class="shiyong">
            产品功能点
            <div class="bg"></div>
          </div>
          <div class="boder">
            <div v-for="(item,index) in tableData"
                 :key="index"
                 class="border-box">

              <div class="model-border">
                <div class="model-top">
                  <div>{{ item.title }}</div>
                  <img :src="item.fileLocal+item.iconUrl"
                       alt="">
                </div>
                <div class="model-test">{{ item.describe }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <transition name="fade">
      <div v-if="switchtab==true"
           class="tab-tow">
        <div class="characters">
          <div class="i">医学检测LIMS方案</div>
          <div class="j">智能 • 高效 • 专业 • 简单易用 • 灵活</div>
        </div>
        <div class="cma">
          <img src="../../assets/组 10@2x.png"
               alt="">
          <div class="text-box">
            <div class="i">基于CMA、CNAS标准开发</div>
            <div class="j">遵循ISO15189《医学实验室质量和能力认可准则》、CNAS-CL01《检测和校准实验室能力认可准则》和CNAS-CL25：2014《检测和校准实验室能力认可准则在校准领域的应用说明》标准，助力CNAS、CMA评审。</div>
          </div>
          <div class="programme">
            <div class="text">
              方案介绍

            </div>
            <div class="p"></div>
            <div class="box1">
              <div class="img"></div>
              <div class="text">
                瑞检软件的医学检测LIMS实现了实验室人（人员）、机（仪器）、料（样品、材料）、法（方法、标准、质量）、 环（环境、通讯）全面资源管理的计算机应用系统，是一套完整的检验综合管理和产品质量监控体系，在满足日常 管理要求，保证检验分析数据的严格管理和控制。它能全面优化实验室的检验管理工作，显著提升实验室的工作效 率和生产力，提高质量控制水平。
              </div>
            </div>
            <div class="box2">
              <div class="img"></div>
              <div class="text">
                检测项目灵活分配或改配到各个检测人员，以便实时统计各个检测人员工作量；实时提醒当事人完成待检验项目；实时查看未检测样品清单；实时查看未检测、已检测未复核和已复核的检测项目，科室负责人可随时查看各项工作最新进展情况，如检测进度、检测报告完成情况等；
              </div>
            </div>
            <div class="box3">
              <div class="img"></div>
              <div class="text">
                支持仪器设备状态、定检、维修、检定到期提醒等管理；
              </div>
            </div>
          </div>
        </div>

        <div class="advantage">
          <div class="text">方案优势</div>
          <div class="p"></div>
          <div class="box">
            <div class="j">
              <div class="boder">
                <div class="i">
                  <div class="text1">产品优势</div>
                  <div class="text2">涵盖全方位精准医学检测项目</div>
                </div>
                <div class="j"><img src="../../assets/组 11 拷贝@2x.png"
                       alt=""></div>
              </div>
              <div class="boder">
                <div class="i">
                  <div class="text1">质量优势</div>
                  <div class="text2">权威检测、通用互认</div>
                </div>
                <div class="j"><img src="../../assets/组 12 拷贝@2x.png"
                       alt=""></div>
              </div>
              <div class="boder">
                <div class="i">
                  <div class="text1">信息化优势</div>
                  <div class="text2">一键下单、医检到家</div>
                </div>
                <div class="j"><img src="../../assets/组 13 拷贝@2x.png"
                       alt=""></div>
              </div>
              <div class="boder">
                <div class="i">
                  <div class="text1">物流优势</div>
                  <div class="text2">提供一站式冷链 物流解决方案</div>
                </div>
                <div class="j">
                  <img src="../../assets/组 14 拷贝@2x.png"
                       alt="">
                </div>
              </div>
            </div>
          </div>
          <div></div>
        </div>
        <div class="expand">
          <div class="text">功能拓展</div>
          <div class="p"></div>
          <div class="text2">整合各种应用,按需购买，像搭积木一样创建个性化的业务流程,满足实验室多样化的办公需求</div>
          <div class="box">
            <div class="border"
                 v-if="tableDatatype[0]">
              <div class="img">
                <img style="width: 100%; height: 100%;"
                     :src="tableDatatype[0].fileLocal+tableDatatype[0].iconUrl"
                     alt="">
              </div>
              <div class="text1">{{tableDatatype[0].title}}</div>
              <div class="text2">{{tableDatatype[0].describe}}</div>
            </div>
            <div class="border"
                 v-if="tableDatatype[1]">
              <div class="img">
                <img style="width: 100%; height: 100%;"
                     :src="tableDatatype[1].fileLocal+tableDatatype[1].iconUrl"
                     alt="">
              </div>
              <div class="text1">{{tableDatatype[1].title}}</div>
              <div class="text2">{{tableDatatype[1].describe}}</div>
            </div>
            <div class="border"
                 v-if="tableDatatype[2]">
              <div class="img">
                <img style="width: 100%; height: 100%;"
                     :src="tableDatatype[0].fileLocal+tableDatatype[2].iconUrl"
                     alt="">
              </div>
              <div class="text1">{{tableDatatype[2].title}}</div>
              <div class="text2">{{tableDatatype[2].describe}}</div>
            </div>
            <div class="border"
                 v-if="tableDatatype[3]">
              <div class="img">
                <img style="width: 100%; height: 100%;"
                     :src="tableDatatype[3].fileLocal+tableDatatype[3].iconUrl"
                     alt="">
              </div>
              <div class="text1">{{tableDatatype[3].title}}</div>
              <div class="text2">{{tableDatatype[3].describe}}</div>
            </div>
          </div>
        </div>
        <div class="more"
             @click="more">
          更多<i class="el-icon-arrow-right"></i>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data () {
    return {
      programme: 'i1',
      product: 'j',
      switchtab: true,
      tableData: [],
      tableDatatype: []
    }
  },
  created () {
    this.getfunctionList()
    if(this.$route.query.id==1){
      this.tab(1)
    }else if(this.$route.query.id==2){
      this.tab(2)
    }
  },
  methods: {
    tab (value) {
      if (value == 1) {
        this.programme = 'i'
        this.product = 'j1'
        this.switchtab = false
      } else {
        this.programme = 'i1'
        this.product = 'j'
        this.switchtab = true
      }
    },
    more () {
      this.switchtab = false
      this.programme = 'i'
      this.product = 'j1'
    },
    getfunctionList () {
      this.api.functionList({
        t: {
          homePageFlag: '1'
        }, p: {}
      }).then((res) => {
        console.log(res)
        this.tableDatatype = res.data.rows
      })
      this.api.functionList({
        t: {

        }, p: {}
      }).then((res) => {
        console.log(res)
        this.tableData = res.data.rows
      })
    }
  },
};
</script>

<style lang="less" scoped>
@media (min-width: 1024px) {
  .fade-leave,   // 离开前,进入后透明度是1
.fade-enter-to {
    opacity: 1;
  }
  .fade-leave-active,
  .fade-enter-active {
    transition: all 0.3s; //过度是2秒
  }
  .fade-leave-to,
  .fade-enter {
    opacity: 0;
  }
  .tab-one {
    // transition: all 0.05s ease-in-out;
    .lims {
      width: 100%;
      height: 100%;
      position: relative;
      .bg {
        width: 74%;
        height: 70%;
        position: absolute;
        left: 13%;
        right: 0;
        top: 0%;
        // border: 1px solid;
        .bg-title {
          margin-top: 6%;
          color: #fff;
          font-size: 34px;
          font-weight: bold;
          letter-spacing: 2.5px;
          font-family: PingFangSC-Medium, PingFang SC;
        }
        .bg-box {
          display: flex;
          margin-top: 5%;
          width: 90%;
          height: 190px;
          // border: 1px solid;
          margin-left: 5%;
          background-color: rgba(67, 134, 148, 0.5);
          border-radius: 20px;
          div {
            font-size: 17px;
            margin-top: 3%;
            line-height: 140%;
            text-align: left;
            color: #fff;
            width: 92%;
            letter-spacing: 1.5px;
            margin-left: 4%;
          }
        }
      }
      img {
        width: 100%;
        height: 100%;
      }
      .web {
        width: 70%;
        height: 75%;
        // position: relative;
        position: absolute;
        left: 15%;
        right: 0;
        top: 67%;
        // top: -240px;
        // z-index: 600;
      }
    }
    .centerBox {
      .shiyong {
        margin: 0 auto;
        width: 126px;
        font-size: 30px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-size: 30px;
        font-weight: bold;
        color: #383838;
        position: relative;
        .bg {
          position: absolute;
          left: -28px;
          top: 20px;
          width: 182px;
          height: 24px;
          background: #367dff;
          opacity: 0.08;
        }
      }
      margin-top: 320px;
      .border {
        // height: 1400px;
        width: 100%;
        background: url("../../assets//我们的产品-背景.png");
        background-size: 100% 100%;
        margin-top: 40px;

        .me-box {
          margin: 0 auto;
          width: 1200px;
          height: 900px;
          // clear:both;
          // border: 1px solid red;
          // height: 1200px;
          overflow: hidden;
          .me-box-test {
            // overflow: hidden;
            // border: 1px solid red;
            // display: flex;
            margin: 0 auto;
            margin-top: 50px;
            margin-bottom: 20px;
            width: 981px;
            height: 161px;
            background: linear-gradient(180deg, #ffffff, #d1dcf0);
            border: 5px solid #d1ddef;
            box-shadow: 0px 25px 24px 0px rgba(0, 19, 47, 0.6);
            border-radius: 16px;
            .me-box-test1 {
              margin-top: 35px;
              font-size: 30px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: bold;
              color: #172d57;
            }
            .me-box-test2 {
              margin-top: 20px;
              font-size: 18px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 300;
              color: #172d57;
            }
          }
          .me-box-border {
            margin: 0 auto;
            margin-top: 50px;
            // margin-left: 4%;
            height: 540px;
            width: 96%;
            // border: 1px solid red;
            display: flex;
            .border-box {
              margin: 0 20px;
              // border: 1px solid red;
              width: 30%;
              .border-box-img {
                width: 275px;
                height: 292px;
              }
              .border-box-kuang {
                margin-top: 50px;
                width: 341px;
                height: 206px;
                // background: #ffffff;
                // border: 1px solid rgba(170, 169, 169, 0.92);
                border-radius: 8px;
                .box-kuang1 {
                  margin: 0 auto;
                  margin-top: 30px;
                  font-size: 23px;
                  width: 247px;
                  line-height: 58px;
                  height: 58px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: bold;
                  color: #ffffff;
                  border: 1px solid rgba(255, 255, 255, 0.92);
                  border-radius: 29px;
                }
                .box-kuang2 {
                  width: 289px;
                  height: 77px;
                  font-size: 18px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 300;
                  color: #e4e4e4;
                  // text-align: left;
                  margin: 0 auto;
                  margin-top: 30px;
                }
              }
            }
          }
          .box-model {
            margin-left: -13px;
            // height: 600px;
            width: 1230px;
            // border: 1px solid red;
            display: flex;
            padding-bottom: 50px;
            flex-wrap: wrap;
            align-content: flex-start;
            .model-border {
              width: 378px;
              height: 187px;
              background: #ffffff;
              border: 2px solid #364664;
              opacity: 0.9;
              margin: 0 15px;
              margin-top: 30px;
              border-radius: 10px;
              .model-border-image {
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bold;
                color: #383838;
                line-height: 187px;
                margin: auto;
              }
              .model-top {
                display: flex;
                width: 314px;
                height: 60px;
                // border: 1px solid red;
                margin: 0 auto;
                margin-top: 30px;
                > div {
                  width: 260px;
                  text-align: left;
                  font-size: 24px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: bold;
                  color: #383838;
                  line-height: 60px;
                }
                > img {
                  // display: flex;
                  justify-content: flex-end;
                  width: 44px;
                  height: 44px;
                }
              }
              .model-test {
                font-family: PingFangSC-Medium, PingFang SC;
                width: 314px;
                // border: 1px solid red;
                height: 80px;
                font-size: 16px;
                font-weight: 300;
                color: #383838;
                line-height: 24px;
                text-align: left;
                margin: 0 auto;
              }
            }
          }
        }
      }
    }
    .product {
      width: 1200px;
      // height: 1000px;
      // text-align: center;
      // display: flex;
      // align-items: center;
      // border: 1px solid;
      position: relative;
      margin: 0 auto;
      top: 50px;
      // left: 50%;
      margin-bottom: 370px;
      .shiyong {
        margin: 0 auto;
        width: 156px;
        font-size: 30px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-size: 30px;
        font-weight: bold;
        color: #383838;
        position: relative;
        .bg {
          position: absolute;
          left: -28px;
          top: 20px;
          width: 212px;
          height: 24px;
          background: #367dff;
          opacity: 0.08;
        }
      }
      .boder {
        margin-top: 20px;
        width: 1230px;
        height: 100%;
        margin-left: -13px;
        // margin-top: 50px;

        // border: 1px solid;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        // justify-content: space-between;
        .model-border {
          width: 376px;
          height: 187px;
          background: #ffffff;
          border: 2px solid #364664;
          opacity: 0.9;
          margin: 0 15px;
          margin-top: 30px;
          border-radius: 10px;
          .model-border-image {
            font-size: 24px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #383838;
            line-height: 187px;
            margin: auto;
          }
          .model-top {
            display: flex;
            width: 314px;
            height: 60px;
            // border: 1px solid red;
            margin: 0 auto;
            margin-top: 30px;
            > div {
              width: 260px;
              text-align: left;
              font-size: 24px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: bold;
              color: #383838;
              line-height: 60px;
            }
            > img {
              // display: flex;
              justify-content: flex-end;
              width: 44px;
              height: 44px;
            }
          }
          .model-test {
            font-family: PingFangSC-Medium, PingFang SC;
            width: 314px;
            // border: 1px solid red;
            height: 80px;
            font-size: 16px;
            font-weight: 300;
            color: #383838;
            line-height: 24px;
            text-align: left;
            margin: 0 auto;
          }
        }
      }
      // margin:-250px 0 0 -250px;
      // left: 50%;
    }
  }
  .tab-tow {
    .characters {
      width: 50%;
      height: 100px;
      // border: 1px solid;
      margin-top: 30px;
      margin-left: 25%;
      margin-bottom: 50px;
      .i {
        font-size: 35px;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #367dffff;
        font-weight: bold;
      }
      .j {
        font-size: 35px;
        font-family: PingFangSC-Medium, PingFang SC;
        color: #6a6a6aff;
        margin-top: 15px;
        font-weight: bold;
      }
    }
    .cma {
      // margin-top: 20px;
      width: 100%;
      height: 100%;
      margin-bottom: 20%;
      position: relative;
      img {
        width: 100%;
        height: 100%;
      }
      .text-box {
        position: absolute;
        top: 20%;
        width: 64%;
        height: 150px;
        margin-left: 18%;
        // border: 1px solid;
        .i {
          font-size: 37px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: #fff;
        }
        .j {
          margin-top: 20px;
          font-size: 22px;
          font-family: PingFangSC-Medium, PingFang SC;
          line-height: 170%;
          // font-weight: 600;
          color: #ffffffff;
          font-weight: 200;
        }
      }
      .programme {
        position: absolute;
        top: 60%;
        width: 1200px;
        height: 85%;
        // border: 1px solid;
        border-radius: 20px;
        // left: 20%;
        margin: auto;
        left: 0;
        right: 0;
        background-color: #ffffffff;
        box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
        .text {
          // border: 1px solid;
          margin-top: 30px;
          font-size: 30px;
          margin-bottom: 15px;
          // padding-bottom: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
        }
        .p {
          // border: 1px solid;
          // margin-top: 20px;
          margin: auto;
          // display: flex;
          width: 50px;
          border-bottom: 1px solid #367dffff;
        }
        .box1 {
          margin-top: 20px;
          width: 90%;
          // border: 1px solid;
          height: 26%;
          margin-left: 5%;
          position: relative;
          .img {
            height: 39px;
            width: 67px;
            background: url("../../assets/solution-box/01@2x.png");
            background-size: 100% 100%;
          }
          .text {
            position: absolute;
            top: -10%;
            left: 4.3%;
            width: 97%;
            // height: 80%;
            // border: 1px solid;
            line-height: 160%;
            text-align: left;
            font-size: 19px;
            font-weight: 300;
            font-family: PingFangSC-Medium, PingFang SC;
            color: #474747;
          }
        }
        .box2 {
          margin-top: 20px;
          width: 90%;
          // border: 1px solid;
          height: 22%;
          margin-left: 5%;
          position: relative;
          .img {
            height: 39px;
            width: 85px;
            background: url("../../assets/solution-box/02@2x.png");
            background-size: 100% 100%;
          }
          .text {
            position: absolute;
            top: -10%;
            left: 4.3%;
            width: 97%;
            // height: 80%;
            // border: 1px solid;
            line-height: 160%;
            text-align: left;
            font-size: 19px;
            font-weight: 300;
            font-family: PingFangSC-Medium, PingFang SC;
            color: #474747;
          }
        }
        .box3 {
          margin-top: 20px;
          width: 90%;
          // border: 1px solid;
          height: 25%;
          margin-left: 5%;
          position: relative;
          .img {
            height: 39px;
            width: 85px;
            background: url("../../assets/solution-box/03@2x.png");
            background-size: 100% 100%;
          }
          .text {
            position: absolute;
            top: -10%;
            left: 4.3%;
            width: 97%;
            // height: 80%;
            // border: 1px solid;
            line-height: 180%;
            text-align: left;
            font-size: 19px;
            font-weight: 300;
            font-family: PingFangSC-Medium, PingFang SC;
            color: #474747;
          }
        }
      }
      // background: url("../../assets/组\ 10@2x.png");
      // background-size: 100% 100%;
    }
    .advantage {
      .text {
        // border: 1px solid;
        margin-top: 30px;
        font-size: 30px;
        margin-bottom: 15px;
        // padding-bottom: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
      }
      .p {
        // border: 1px solid;
        // margin-top: 20px;
        margin: auto;
        // display: flex;
        width: 50px;
        border-bottom: 1px solid #367dffff;
      }
      .box {
        display: table;
        border-collapse: collapse;
        margin: 0 auto;
        width: 1200px;
        height: 300px;
        // border: 1px solid red;
        margin-top: 30px;
        .j {
          display: flex;
          flex-wrap: wrap;
          align-content: flex-start;
          justify-content: space-between;
          .boder {
            margin-bottom: 40px;
            border-radius: 20px;
            width: 580px;
            height: 200px;
            // border: 1px solid red;
            display: flex;
            .i {
              width: 50%;
              height: 100%;
              border-top-left-radius: 20px;
              border-bottom-left-radius: 20px;
              // border: 1px solid red;
              background-color: #f3f3f3ff;
              .text1 {
                margin-top: 30px;
                font-size: 28px;
                font-weight: 600;
                margin-left: 45px;
                float: left;
                font-family: PingFangSC-Medium, PingFang SC;
              }
              .text2 {
                width: 60%;
                text-align: left;
                margin-top: 20px;
                font-size: 20px;
                line-height: 160%;
                font-weight: 300;
                margin-left: 45px;
                float: left;
                font-family: PingFangSC-Medium, PingFang SC;
              }
            }
            .j {
              width: 50%;
              border-top-right-radius: 20px;
              border-bottom-right-radius: 20px;
              height: 100%;
              // z-index: 5;
              overflow: hidden;
              img {
                width: 100%;
                border-top-right-radius: 20px;
                border-bottom-right-radius: 20px;
                height: 100%;
                transition: all 0.6s;
                // z-index: 4;
              }
            }
          }
          .boder:hover {
            margin-bottom: 40px;
            border-radius: 20px;
            width: 580px;
            height: 200px;
            cursor: pointer;
            // border: 1px solid red;
            display: flex;
            .i {
              width: 50%;
              height: 100%;
              border-top-left-radius: 20px;
              border-bottom-left-radius: 20px;
              // border: 1px solid red;
              background-color: #367dffff;
              .text1 {
                margin-top: 30px;
                font-size: 28px;
                font-weight: 600;
                margin-left: 45px;
                color: #fff;
                float: left;
                font-family: PingFangSC-Medium, PingFang SC;
              }
              .text2 {
                width: 60%;
                color: #fff;
                text-align: left;
                margin-top: 20px;
                font-size: 20px;
                line-height: 160%;
                font-weight: 300;
                margin-left: 45px;
                float: left;
                font-family: PingFangSC-Medium, PingFang SC;
              }
            }
            .j {
              width: 50%;
              border-top-right-radius: 20px;
              border-bottom-right-radius: 20px;
              height: 100%;
              img {
                width: 100%;
                border-top-right-radius: 20px;
                border-bottom-right-radius: 20px;
                height: 100%;
                transform: scale(1.12);
              }
            }
          }
        }
      }
    }
    .expand {
      margin-bottom: 30px;
      .text {
        // border: 1px solid;
        margin-top: 30px;
        font-size: 30px;
        margin-bottom: 15px;
        // padding-bottom: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
      }
      .p {
        // border: 1px solid;
        // margin-top: 20px;
        margin: auto;
        // display: flex;
        width: 50px;
        border-bottom: 1px solid #367dffff;
      }
      .text2 {
        margin-top: 15px;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
      }
      .box {
        display: table;
        border-collapse: collapse;
        margin: 0 auto;
        width: 1200px;
        height: 300px;
        // border: 1px solid red;
        margin-top: 30px;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        justify-content: space-between;
        .border {
          width: 260px;
          height: 280px;
          // border: 1px solid red;
          background-color: #fff;
          border-radius: 20px;
          box-shadow: 1px 0px 8px 4px rgba(0, 0, 0, 0.1);
          // animation: animated-border 1.5s infinite;
          .img {
            width: 45px;
            // display: table;
            border-collapse: collapse;
            margin: 0 auto;
            margin-top: 40px;
            height: 45px;
            // border: 1px solid red;
          }
          .text1 {
            margin-top: 26px;
            font-size: 19px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            letter-spacing: 2px;
          }
          .text2 {
            display: table;
            border-collapse: collapse;
            margin: 0 auto;
            width: 70%;
            margin-top: 20px;
            font-size: 15px;
          }
        }
        .border:hover {
          // position: absolute;
          // width: 100px;
          // height: 100px;
          width: 260px;
          cursor: pointer;
          height: 280px;
          // border: 1px solid red;
          background-color: #fff;
          border-radius: 20px;

          box-shadow: 1px 0px 8px 5px rgba(0, 0, 0, 0.1);
          animation: oscillate 1s cubic-bezier(0.17, 0.67, 0.45, 1.32) infinite
            alternate;
        }
        @keyframes oscillate {
          from {
            transform: scale(1, 1);
          }
          to {
            transform: scale(1.1, 1.1);
          }
        }
      }
    }
    .more {
      cursor: pointer;
      margin-bottom: 70px;
      color: #367dffff;
    }
  }
  .top {
    height: 100%;
    width: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .tab-bar {
    margin: 0 auto;
    width: 1200px;
    height: 107px;
    .tab-box {
      margin-left: 7px;
      margin-top: 45px;
      width: 380px;
      height: 40px;
      // border: 1px solid;
      display: flex;
      .i {
        cursor: pointer;
        width: 159px;
        height: 100%;
        border: 1px solid #367dffff;
        .test {
          font-size: 15px;
          margin-top: 10px;
          font-weight: bold;
        }
      }
      .i1 {
        cursor: pointer;
        width: 159px;
        height: 100%;
        border: 1px solid #367dffff;
        background-color: #367dffff;
        .test {
          font-size: 15px;
          margin-top: 10px;
          font-weight: bold;
          color: aliceblue;
        }
      }
      .j {
        cursor: pointer;
        margin-left: 20px;
        width: 159px;
        height: 100%;
        border: 1px solid #367dffff;
        .test {
          font-size: 15px;
          margin-top: 10px;
          font-weight: bold;
        }
      }
      .j1 {
        cursor: pointer;
        margin-left: 20px;
        width: 159px;
        height: 100%;
        border: 1px solid #367dffff;
        background-color: #367dffff;
        .test {
          font-size: 15px;
          margin-top: 10px;
          font-weight: bold;
          color: aliceblue;
        }
      }
    }
    .p {
      margin-top: 26px;
      margin-left: -70px;
      width: 1340px;
      border-bottom: 1px solid #367dffff;
    }
  }
}
@media (max-width: 1024px) {
  .fade-leave,   // 离开前,进入后透明度是1
.fade-enter-to {
    opacity: 1;
  }
  .fade-leave-active,
  .fade-enter-active {
    transition: all 0.3s; //过度是2秒
  }
  .fade-leave-to,
  .fade-enter {
    opacity: 0;
  }
  .top {
    height: 100%;
    width: 100%;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .tab-bar {
    width: 100%;
    height: 107px;
    .tab-box {
      margin-left: 30px;
      margin-top: 45px;
      width: 80%;
      height: 40px;
      // border: 1px solid;
      display: flex;
      .i {
        width: 159px;
        height: 100%;
        border: 1px solid #367dffff;
        .test {
          font-size: 13px;
          margin-top: 10px;
          font-weight: bold;
        }
      }
      .i1 {
        width: 159px;
        height: 100%;
        border: 1px solid #367dffff;
        background-color: #367dffff;
        .test {
          font-size: 13px;
          margin-top: 10px;
          font-weight: bold;
          color: aliceblue;
        }
      }
      .j {
        margin-left: 20px;
        width: 159px;
        height: 100%;
        border: 1px solid #367dffff;
        .test {
          font-size: 13px;
          margin-top: 10px;
          font-weight: bold;
        }
      }
      .j1 {
        margin-left: 20px;
        width: 159px;
        height: 100%;
        border: 1px solid #367dffff;
        background-color: #367dffff;
        .test {
          font-size: 13px;
          margin-top: 10px;
          font-weight: bold;
          color: aliceblue;
        }
      }
    }
    .p {
      margin-top: 26px;
      margin-left: 20px;
      width: 85%;
      border-bottom: 1px solid #367dffff;
    }
  }
  .lims {
    width: 100%;
    height: 100%;
    position: relative;
    img {
      width: 100%;
      height: 280px;
    }
    .web {
      width: 90%;
      height: 90%;
      // position: relative;
      // top: -55px;
      // z-index: 600;
    }
    .bg {
      width: 94%;
      height: 35%;
      position: absolute;
      left: 3%;
      right: 0;
      top: -3%;
      // border: 1px solid;
      .bg-title {
        margin-top: 7%;
        color: #fff;
        font-size: 16px;
        font-weight: bold;
        letter-spacing: 2.5px;
        font-family: PingFangSC-Medium, PingFang SC;
      }
      .bg-box {
        display: flex;
        margin-top: 3%;
        width: 94%;
        height: 220px;
        // border: 1px solid;
        margin-left: 3%;
        background-color: rgba(67, 134, 148, 0.5);
        border-radius: 20px;
        div {
          font-size: 10px;
          margin-top: 3%;
          line-height: 140%;
          text-align: left;
          color: #fff;
          width: 92%;
          letter-spacing: 1.5px;
          margin-left: 4%;
        }
      }
    }
  }
  .centerBox {
    .shiyong {
      margin: 0 auto;
      width: 126px;
      font-size: 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-size: 30px;
      font-weight: bold;
      color: #383838;
      position: relative;
      .bg {
        position: absolute;
        left: -28px;
        top: 20px;
        width: 182px;
        height: 24px;
        background: #367dff;
        opacity: 0.08;
      }
    }
    margin-top: 20px;
    .border {
      // height: 1400px;
      width: 100%;
      background: url("../../assets//我们的产品-背景.png");
      background-size: 100% 100%;
      margin-top: 40px;

      .me-box {
        margin: 0 auto;
        width: 320px;
        height: 1900px;
        // clear:both;
        // border: 1px solid red;
        // height: 1200px;
        overflow: hidden;
        .me-box-test {
          // overflow: hidden;
          // border: 1px solid red;
          // display: flex;
          margin: 0 auto;
          margin-top: 50px;
          margin-bottom: 20px;
          width: 300px;
          height: 161px;
          background: linear-gradient(180deg, #ffffff, #d1dcf0);
          border: 5px solid #d1ddef;
          box-shadow: 0px 25px 24px 0px rgba(0, 19, 47, 0.6);
          border-radius: 16px;
          .me-box-test1 {
            margin: 0 auto;
            width: 280px;
            margin-top: 15px;
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #172d57;
          }
          .me-box-test2 {
            margin: 0 auto;
            width: 280px;
            margin-top: 20px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 300;
            color: #172d57;
          }
        }
        .me-box-border {
          margin: 0 auto;
          margin-top: 50px;
          // margin-left: 4%;
          height: 540px;
          width: 320px;
          // border: 1px solid red;
          display: flex;
          flex-wrap: wrap;
          .border-box {
            // margin: 0 20px;
            // border: 1px solid red;
            width: 320px;
            .border-box-img {
              width: 275px;
              height: 292px;
            }
            .border-box-kuang {
              margin-top: 50px;
              // width: 341px;
              height: 206px;
              // background: #ffffff;
              // border: 1px solid rgba(170, 169, 169, 0.92);
              border-radius: 8px;
              .box-kuang1 {
                margin: 0 auto;
                margin-top: 30px;
                font-size: 23px;
                width: 247px;
                line-height: 58px;
                height: 58px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bold;
                color: #ffffff;
                border: 1px solid rgba(255, 255, 255, 0.92);
                border-radius: 29px;
              }
              .box-kuang2 {
                width: 289px;
                height: 77px;
                font-size: 18px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 300;
                color: #e4e4e4;
                // text-align: left;
                margin: 0 auto;
                margin-top: 30px;
              }
            }
          }
        }
        .box-model {
          margin-left: -13px;
          // height: 600px;
          width: 1230px;
          // border: 1px solid red;
          display: flex;
          padding-bottom: 50px;
          flex-wrap: wrap;
          align-content: flex-start;
          .model-border {
            width: 378px;
            height: 187px;
            background: #ffffff;
            border: 2px solid #364664;
            opacity: 0.9;
            margin: 0 15px;
            margin-top: 30px;
            border-radius: 10px;
            .model-border-image {
              font-size: 24px;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: bold;
              color: #383838;
              line-height: 187px;
              margin: auto;
            }
            .model-top {
              display: flex;
              width: 314px;
              height: 60px;
              // border: 1px solid red;
              margin: 0 auto;
              margin-top: 30px;
              > div {
                width: 260px;
                text-align: left;
                font-size: 24px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: bold;
                color: #383838;
                line-height: 60px;
              }
              > img {
                // display: flex;
                justify-content: flex-end;
                width: 44px;
                height: 44px;
              }
            }
            .model-test {
              font-family: PingFangSC-Medium, PingFang SC;
              width: 314px;
              // border: 1px solid red;
              height: 80px;
              font-size: 16px;
              font-weight: 300;
              color: #383838;
              line-height: 24px;
              text-align: left;
              margin: 0 auto;
            }
          }
        }
      }
    }
  }
  .product {
    width: 100%;
    height: 100%;
    // text-align: center;
    // display: flex;
    // align-items: center;
    // border: 1px solid;
    // position: relative;
    // top: -30px;
    // left: 18%;
    .shiyong {
      margin: 0 auto;
      margin-top: 20px;
      width: 156px;
      font-size: 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-size: 30px;
      font-weight: bold;
      color: #383838;
      position: relative;
      .bg {
        position: absolute;
        left: -28px;
        top: 20px;
        width: 212px;
        height: 24px;
        background: #367dff;
        opacity: 0.08;
      }
    }
    .boder {
      width: 320px;
      height: 100%;
      // margin-top: 50px;
      margin: 0 auto;
      padding-bottom: 50px;

      // border: 1px solid;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      justify-content: space-between;
      .model-border {
        width: 320px;
        height: 177px;
        background: #ffffff;
        border: 2px solid #364664;
        opacity: 0.9;
        // margin: 0 15px;
        margin-top: 30px;
        border-radius: 10px;
        .model-border-image {
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: bold;
          color: #383838;
          line-height: 177px;
          margin: auto;
        }
        .model-top {
          display: flex;
          width: 260px;
          height: 60px;
          // border: 1px solid red;
          margin: 0 auto;
          margin-top: 30px;
          > div {
            width: 196px;
            text-align: left;
            font-size: 22px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: bold;
            color: #383838;
            line-height: 60px;
          }
          > img {
            // display: flex;
            justify-content: flex-end;
            width: 44px;
            height: 44px;
          }
        }
        .model-test {
          width: 260px;
          // border: 1px solid red;
          height: 80px;
          font-size: 14px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 300;
          color: #383838;
          line-height: 24px;
          text-align: left;
          margin: 0 auto;
        }
      }
    }
    // margin:-250px 0 0 -250px;
    // left: 50%;
  }
  .characters {
    width: 90%;
    height: 100px;
    // border: 1px solid;
    margin-top: 20px;
    margin-left: 5%;
    // margin-bottom: 50px;
    .i {
      font-size: 25px;
      font-family: PingFangSC-Medium, PingFang SC;
      color: #367dffff;
      font-weight: bold;
    }
    .j {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      color: #6a6a6aff;
      margin-top: 15px;
      font-weight: bold;
    }
  }
  .cma {
    // margin-top: 20px;
    width: 100%;
    height: 100%;
    // margin-bottom: 90%;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    .text-box {
      position: absolute;
      top: 3%;
      width: 90%;
      height: 150px;
      margin-left: 5%;
      // border: 1px solid;
      .i {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #fff;
      }
      .j {
        // margin-top: 20px;
        font-size: 10px;
        line-height: 160%;
        // font-weight: 600;
        color: #ffffffff;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 300;
      }
    }
    .programme {
      // position: absolute;
      // top: 10%;
      width: 350px;
      height: 400px;
      // border: 1px solid;
      border-radius: 20px;
      // left: 20%;
      margin: auto;
      left: 0;
      right: 0;
      background-color: #ffffffff;
      box-shadow: 1px 5px 15px rgba(0, 0, 0, 0.1);
      .text {
        // border: 1px solid;
        margin-top: 20px;
        font-size: 20px;
        margin-bottom: 10px;
        // padding-bottom: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
      }
      .p {
        // border: 1px solid;
        // margin-top: 20px;
        margin: auto;
        // display: flex;
        width: 50px;
        border-bottom: 1px solid #367dffff;
      }
      .box1 {
        margin-top: 10px;
        width: 90%;
        // border: 1px solid;
        height: 33%;
        margin-left: 4%;
        position: relative;
        .img {
          height: 29px;
          width: 57px;
          background: url("../../assets/solution-box/01@2x.png");
          background-size: 100% 100%;
        }
        .text {
          position: absolute;
          top: -10%;
          left: 6%;
          width: 95%;
          // height: 80%;
          // border: 1px solid;
          line-height: 150%;
          text-align: left;
          font-size: 12px;
          font-weight: 300;
          font-family: PingFangSC-Medium, PingFang SC;
          color: #474747;
        }
      }
      .box2 {
        margin-top: 10px;
        width: 90%;
        // border: 1px solid;
        height: 27%;
        margin-left: 4%;
        position: relative;
        .img {
          height: 29px;
          width: 75px;
          background: url("../../assets/solution-box/02@2x.png");
          background-size: 100% 100%;
        }
        .text {
          position: absolute;
          top: -10%;
          left: 5%;
          width: 95%;
          // height: 80%;
          // border: 1px solid;
          line-height: 160%;
          text-align: left;
          font-size: 12px;
          font-weight: 300;
          font-family: PingFangSC-Medium, PingFang SC;
          color: #474747;
        }
      }
      .box3 {
        margin-top: 20px;
        width: 90%;
        // border: 1px solid;
        height: 25%;
        margin-left: 4%;
        position: relative;
        .img {
          height: 29px;
          width: 75px;
          background: url("../../assets/solution-box/03@2x.png");
          background-size: 100% 100%;
        }
        .text {
          position: absolute;
          top: -10%;
          left: 5%;
          width: 95%;
          // height: 80%;
          // border: 1px solid;
          line-height: 160%;
          text-align: left;
          font-size: 12px;
          font-weight: 300;
          font-family: PingFangSC-Medium, PingFang SC;
          color: #474747;
        }
      }
    }
    // background: url("../../assets/组\ 10@2x.png");
    // background-size: 100% 100%;
  }
  .advantage {
    .text {
      // border: 1px solid;
      margin-top: 30px;
      font-size: 20px;
      margin-bottom: 15px;
      // padding-bottom: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
    }
    .p {
      // border: 1px solid;
      // margin-top: 20px;
      margin: auto;
      // display: flex;
      width: 50px;
      border-bottom: 1px solid #367dffff;
    }
    .box {
      display: table;
      border-collapse: collapse;
      margin: 0 auto;
      width: 300px;
      height: 300px;
      // border: 1px solid red;
      margin-top: 30px;
      .j {
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
        justify-content: space-between;
        .boder {
          margin-bottom: 40px;
          border-radius: 20px;
          width: 350px;
          height: 150px;
          // border: 1px solid red;
          display: flex;
          .i {
            width: 50%;
            height: 100%;
            border-top-left-radius: 20px;
            border-bottom-left-radius: 20px;
            // border: 1px solid red;
            background-color: #f3f3f3ff;
            .text1 {
              margin-top: 30px;
              font-size: 20px;
              font-weight: 600;
              margin-left: 45px;
              float: left;
              font-family: PingFangSC-Medium, PingFang SC;
            }
            .text2 {
              width: 60%;
              text-align: left;
              margin-top: 10px;
              font-size: 12px;
              line-height: 160%;
              font-weight: 300;
              margin-left: 45px;
              float: left;
              font-family: PingFangSC-Medium, PingFang SC;
            }
          }
          .j {
            width: 50%;
            border-top-right-radius: 20px;
            border-bottom-right-radius: 20px;
            height: 100%;
            img {
              width: 100%;
              border-top-right-radius: 20px;
              border-bottom-right-radius: 20px;
              height: 100%;
            }
          }
        }
        .boder:hover {
          margin-bottom: 40px;
          border-radius: 20px;
          width: 350px;
          height: 150px;
          // border: 1px solid red;
          display: flex;
          .i {
            width: 50%;
            height: 100%;
            border-top-left-radius: 20px;
            border-bottom-left-radius: 20px;
            // border: 1px solid red;
            background-color: rgb(34, 17, 192);
            .text1 {
              margin-top: 30px;
              font-size: 20px;
              font-weight: 600;
              margin-left: 45px;
              float: left;
              font-family: PingFangSC-Medium, PingFang SC;
            }
            .text2 {
              width: 60%;
              text-align: left;
              margin-top: 10px;
              font-size: 12px;
              line-height: 160%;
              font-weight: 300;
              margin-left: 45px;
              float: left;
              font-family: PingFangSC-Medium, PingFang SC;
            }
          }
          .j {
            width: 50%;
            border-top-right-radius: 20px;
            border-bottom-right-radius: 20px;
            height: 100%;
            img {
              width: 100%;
              border-top-right-radius: 20px;
              border-bottom-right-radius: 20px;
              height: 100%;
            }
          }
        }
      }
    }
  }

  .expand {
    margin-bottom: 30px;
    .text {
      // border: 1px solid;
      margin-top: 30px;
      font-size: 20px;
      margin-bottom: 15px;
      // padding-bottom: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
    }
    .p {
      // border: 1px solid;
      // margin-top: 20px;
      margin: auto;
      // display: flex;
      width: 50px;
      border-bottom: 1px solid #367dffff;
    }
    .text2 {
      margin-left: 20px;
      margin-right: 20px;
      margin-top: 15px;
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
    }
    .box {
      display: table;
      border-collapse: collapse;
      margin: 0 auto;
      width: 260px;
      height: 1150px;
      // border: 1px solid red;
      margin-top: 30px;
      display: flex;
      flex-wrap: wrap;
      align-content: flex-start;
      justify-content: space-between;
      .border {
        width: 260px;
        height: 260px;
        margin-bottom: 30px;
        // border: 1px solid red;
        background-color: #fff;
        border-radius: 20px;
        box-shadow: 1px 0px 8px 4px rgba(0, 0, 0, 0.1);
        // animation: animated-border 1.5s infinite;
        .img {
          width: 72px;
          display: table;
          border-collapse: collapse;
          margin: 0 auto;
          margin-top: 40px;
          height: 72px;
          // border: 1px solid red;
        }
        .text1 {
          margin-top: 26px;
          font-size: 19px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          letter-spacing: 2px;
        }
        .text2 {
          display: table;
          border-collapse: collapse;
          margin: 0 auto;
          width: 70%;
          margin-top: 20px;
          font-size: 15px;
        }
      }
      .border:hover {
        // position: absolute;
        // width: 100px;
        // height: 100px;
        width: 260px;
        height: 280px;
        // border: 1px solid red;
        background-color: #fff;
        border-radius: 20px;

        box-shadow: 1px 0px 8px 5px rgba(0, 0, 0, 0.1);
        animation: oscillate 1s cubic-bezier(0.17, 0.67, 0.45, 1.32) infinite
          alternate;
      }
      @keyframes oscillate {
        from {
          transform: scale(1, 1);
        }
        to {
          transform: scale(1.1, 1.1);
        }
      }
    }
  }
  .more {
    margin-bottom: 50px;
    color: #367dffff;
  }
}
</style>
